import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DashboardsComponent } from './dashboards/dashboards.component';
import { DashboardsWidgetService } from './services/dashboards.widget.service';
import { DashboardsUpdateService } from './services/dashboards.update.service';
import { DashboardsLayoutService } from './services/dashboards.layout.service';

@NgModule({
    declarations: [
        DashboardsComponent
    ],
    imports: [
        FormsModule,
        CommonModule
    ],
    providers: [
        DashboardsWidgetService,
        DashboardsUpdateService,
        DashboardsLayoutService
    ],
    exports: [
        DashboardsComponent
    ],
    entryComponents: [
        DashboardsComponent
    ]
})
export class DashboardsModule {
}
